import { render, staticRenderFns } from "./Observations.vue?vue&type=template&id=5e47a0c4"
import script from "./Observations.vue?vue&type=script&lang=js"
export * from "./Observations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports